import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';
import backgroundImage from '../assets/images/home/bg.jpg'
import startBtnImage from '../assets/images/home/start.png';

import Cookies from 'universal-cookie';
import fetchTimeout from 'fetch-timeout';
import loginPanel from '../assets/images/login/login_panel.png'
import loginBtn from '../assets/images/login/login.png'
import cancelBtn from '../assets/images/login/pass.png'

import constant from '../assets/const.json';

const cookies = new Cookies();

class Home extends Component {

    btnSound = './sounds/button_sound.mp3';

    constructor(props) {
        super(props);
        this.state = {
            uid: '',
            showDialog: false
        };
    }
    
    componentDidMount() {
        let uid = cookies.get('uid');
        if (uid === null || uid === undefined) {
            uid = ''
        }
        this.setState({
            uid: uid
        });
    }

    getRequestBody(uid) {
        return {
            uid: uid,
            action: 'start'
        };
    }

    postDataToServer(uid) {
        let apiPath = constant.WEB_API_PATH;
		fetchTimeout(apiPath, {
            headers: {
                'Content-Type': 'application/json'
            },
			method: 'POST',
			body: JSON.stringify(this.getRequestBody(uid))
        }, 5 * 1000, '[WebAPI] Timeout')
        .then(response => response.json())
		.then(data => {
			if (data.success) {
                // call api ok
                console.log('[WebAPI] success');
            } else {
                // call api failed
                console.log('[WebAPI] failed');
            }
		}).catch(e => {
			console.log('[WebAPI] ' + e);
		});
    }
    
    goToGameIntroPage() {
        this.playBtnSound();
        this.postDataToServer(this.state.uid);
        if (this.state.uid === '') {
            this.setState({
                showDialog: true
            });
        } else {
            this.forceGoToGameIntroPage()
        }
    };

    forceGoToGameIntroPage() {
        this.playBtnSound();
        this.props.history.push({
            pathname: './game-intro',
            state: {}
        });
    }

    goToLoginPage() {
        this.playBtnSound();
        window.top.location = constant.LOGIN_URL
    }

    playBtnSound() {
        let btnAudio = new Audio(this.btnSound);
        btnAudio.play();
    }

    render() {
        return (
            <div className='page-root-div'>
                <img alt='' src={backgroundImage} style={{ width: '100%', height: '100%', overflow: 'hidden', objectFit: 'cover', position: 'absolute' }}/>
                {
                    !this.state.showDialog && (<img className='press-btn' alt='' src={startBtnImage} style={{ height: '12%', bottom: '14%', left: '38.5%', position: 'absolute' }} onClick={this.goToGameIntroPage.bind(this)}/>)
                }
                {
                    this.state.showDialog && (<div style={{ position: 'absolute', height: '60.5%', width: '62%', left: '18.8%', top: '18%', background: 'transparent', zIndex: '1' }}>
                        <img alt='' src={loginPanel} style={{ position: 'absolute', width: '100%', height: '100%', left: '0px', top: '0px' }}></img>
                        <img alt='' className='press-btn' src={loginBtn} style={{ position: 'absolute', width: '29%', height: '20%', left: '7.5%', bottom: '7%' }} onClick={this.goToLoginPage.bind(this)}></img>
                        <img alt='' className='press-btn' src={cancelBtn} style={{ position: 'absolute', width: '29%', height: '20%', right: '7.5%', bottom: '7%' }} onClick={this.forceGoToGameIntroPage.bind(this)}></img>
                    </div>)
                }
            </div>
        )
    }
}

export default withRouter(Home);
